import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";

export default function Conditions(props) {

    const {controller = "", callback = () => { }, value = "", route = "" } = props;
    const [data, setData] = useState([])
    const [selected, setSelected] = useState("");

    const none = {
        "code": " ",
        "description": "New",
        "section_override": "",
        "show_on_orders": true,
        "show_original_price": true,
        "used": null,
        "used_condition": " "
    }

    useEffect(() => {
        pubCall("condition.getAll", {}, (_s, _r) => {
            if (_s) {
                _r = [{...none}].concat(_r);
                let _f = _r.find(item => item?.code === value);
                if (_f) { setSelected(_f); } else { setSelected(_r[0])}
                setData(_r);

            } else {
                showError(_r);
            }
        })

    }, [])





    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected?.code) } }
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.code === selected?.code) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.code === selected?.code) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}
    };

    const columns = [
        { key: "description", align: "left", title: <>Description</>, width: 240 },
        { key: "code", align: "center", title: <>Code</>, width: 38 },
    ]

    // return(<>{JSON.stringify(menu, null, 2)}</>)



    return (<>
        <Popup 
            title={"Condition Code"} 
            width={"auto"} 
            callback={callback} 
            component={<VirtualTable
                controller={controller}
                row_key={"code"}
                next={next}
                prev={prev}
                route={route}
                current={selected}
                data={data}
                width={300}
                height={388}
                offset={0}
                columns={columns}
                onRowClick={(item, event, index) => { callback(item?.code) }}
            />} 
        />
    </>)
}